import React from 'react'
import './App.css'
import './Editprofile.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { IoIosArrowBack } from 'react-icons/io'
import { IoPersonOutline, IoShareSocialOutline, IoImageOutline } from 'react-icons/io5'
import { BiMenu } from 'react-icons/bi'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const BIO_MAX = 500
const PITCH_MAX = 1000
const PHOTO_MAX_BYTES = 2 * 1024 * 1024
const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp']

/* profile_photo is stored as a relative path; full URLs pass through untouched */
const photoSrc = (path) => {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  return `${API_URL}/${String(path).replace(/^\/+/, '')}`
}

class Editprofile extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      accountname: '',
      phone: '',
      email: '',
      facebook: '',
      twitter: '',
      instagram: '',
      linkedin: '',
      tiktok: '',
      address: '',
      // partner-only fields
      partner_type: '',
      bio: '',
      pitch: '',
      follower_estimate: '',
      profile_photo: '',
      photoFile: null,
      photoPreview: '',
      spinning: 'none',
      updateDisplay: 'block',
      updated_at: '',
      loggedAccountType: '',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    // alert(localStorage.getItem("partnername"));
    if (localStorage.getItem('customername') !== null) {
      const customername = localStorage.getItem('customername')
      const customerid = localStorage.getItem('customerid')
      document.title = 'Edit profile - ' + customername + ' - Customer'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            accountname: response.data.customername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            updated_at: response.data.updated_at,
            loggedAccountType: response.data.loggedAccountType,
          })
        })
        .catch(function (error) {
          alert(error)
        })
    } else if (localStorage.getItem('businessname') !== null) {
      const businessname = localStorage.getItem('businessname')
      const businessid = localStorage.getItem('businessid')
      document.title = 'Edit profile - ' + businessname + ' - Business'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS&accountid=${businessid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            accountname: response.data.businessname,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            facebook: response.data.facebook,
            twitter: response.data.twitter,
            instagram: response.data.instagram,
            linkedin: response.data.linkedin,
            tiktok: response.data.tiktok,
            address: response.data.address,
            updated_at: response.data.updated_at,
            loggedAccountType: response.data.loggedAccountType,
          })
        })
        .catch(function (error) {
          alert(error)
        })
    } else {
      const partnername = localStorage.getItem('partnername')
      const partnerid = localStorage.getItem('partnerid')
      document.title = 'Edit profile - ' + partnername + ' - Sales partner'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            accountname: response.data.partnername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            updated_at: response.data.updated_at,
            facebook: response.data.facebook,
            twitter: response.data.twitter,
            instagram: response.data.instagram,
            linkedin: response.data.linkedin,
            tiktok: response.data.tiktok,
            partner_type: response.data.partner_type || '',
            bio: response.data.bio || '',
            pitch: response.data.pitch || '',
            follower_estimate: response.data.follower_estimate || '',
            profile_photo: response.data.profile_photo || '',
            loggedAccountType: response.data.loggedAccountType,
          })
        })
        .catch(function (error) {
          alert(error)
        })
    }
  }

  handleCustomername = (event) => {
    this.setState({
      accountname: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEmail = (event) => {
    this.setState({
      email: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePhone = (event) => {
    this.setState({
      phone: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleFacebook = (event) => {
    this.setState({
      facebook: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTwitter = (event) => {
    this.setState({
      twitter: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleInstagram = (event) => {
    this.setState({
      instagram: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleLinkedin = (event) => {
    this.setState({
      linkedin: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTiktok = (event) => {
    this.setState({
      tiktok: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleAddress = (event) => {
    this.setState({
      address: event.target.value,
      errorDisplay: 'none',
    })
  }

  /* Partner-only handlers */
  handlePartnerType = (event) => {
    this.setState({ partner_type: event.target.value, errorDisplay: 'none' })
  }

  handleFollowerEstimate = (event) => {
    this.setState({ follower_estimate: event.target.value, errorDisplay: 'none' })
  }

  handleBio = (event) => {
    this.setState({ bio: event.target.value.slice(0, BIO_MAX), errorDisplay: 'none' })
  }

  handlePitch = (event) => {
    this.setState({ pitch: event.target.value.slice(0, PITCH_MAX), errorDisplay: 'none' })
  }

  showError = (message) => {
    this.setState({
      error: message,
      errorDisplay: 'block',
      successError: 'error-login',
    })
    setTimeout(() => {
      this.setState({ errorDisplay: 'none' })
    }, 4000)
  }

  handlePhoto = (event) => {
    const file = event.target.files && event.target.files[0]
    event.target.value = '' // lets the same file be picked again
    if (!file) return

    if (!PHOTO_TYPES.includes(file.type)) {
      this.showError('Photo must be a JPG, PNG or WEBP image')
      return
    }
    if (file.size > PHOTO_MAX_BYTES) {
      this.showError('Photo must be 2MB or smaller')
      return
    }

    if (this.state.photoPreview) URL.revokeObjectURL(this.state.photoPreview)
    this.setState({
      photoFile: file,
      photoPreview: URL.createObjectURL(file),
      errorDisplay: 'none',
    })
  }

  update = () => {
    let accountid = 0
    this.setState({ updateDisplay: 'none', spinning: 'block' })
    const accounttype = localStorage.getItem('accounttype')
    const phone = this.state.phone
    const email = this.state.email
    const isPartner =
      localStorage.getItem('customername') === null && localStorage.getItem('businessname') === null

    if (
      this.state.accountname.trim() == '' ||
      this.state.email.trim() == '' ||
      this.state.phone == ''
    ) {
      this.setState({ updateDisplay: 'block', spinning: 'none' })
      this.setState({
        error: 'All fields are required',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else {
      const baseURL = `${API_URL}/apps/kscanner/webservices.php`
      const data = new FormData()
      data.append('accountname', this.state.accountname)
      data.append('phone', this.state.phone)
      data.append('email', this.state.email)
      data.append('facebook', this.state.facebook)
      data.append('twitter', this.state.twitter)
      data.append('instagram', this.state.instagram)
      data.append('linkedin', this.state.linkedin)
      data.append('tiktok', this.state.tiktok)
      data.append('address', this.state.address)
      if (isPartner) {
        data.append('partner_type', this.state.partner_type)
        data.append('bio', this.state.bio)
        data.append('pitch', this.state.pitch)
        data.append('follower_estimate', this.state.follower_estimate)
        if (this.state.photoFile) {
          data.append('profile_photo', this.state.photoFile)
        }
      }
      data.append('query', 'EDITACCOUNTDETAILS')
      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          this.setState({ updateDisplay: 'block', spinning: 'none' })
          let assignClass = ''
          if (response.data.status === 'failed') {
            assignClass = 'error-login'
          } else {
            assignClass = 'success-login'

            // Photo saved: swap the preview for the stored path
            if (this.state.photoFile) {
              if (this.state.photoPreview) URL.revokeObjectURL(this.state.photoPreview)
              this.setState({
                profile_photo: response.data.profile_photo || this.state.profile_photo,
                photoFile: null,
                photoPreview: '',
              })
            }
          }
          this.setState({
            error: response.data.message,
            errorDisplay: 'block',
            successError: assignClass,
          })

          setTimeout(() => {
            this.setState({ errorDisplay: 'none' })
          }, 4000)
        })
        .catch((error) => {
          console.log(error)
          this.setState({ updateDisplay: 'block', spinning: 'none' })
          this.showError('Something went wrong. Please try again.')
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
    if (this.state.photoPreview) URL.revokeObjectURL(this.state.photoPreview)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  /* Update button — same behaviour everywhere it is used */
  renderUpdateButton = () => (
    <button
      type="button"
      disabled={this.state.spinning === 'block' ? true : false}
      className={`ep-btn ${this.state.spinning === 'block' ? 'ep-btn--off' : 'ep-btn--primary'}`}
      onClick={() => this.update()}
    >
      <span
        style={{
          display: this.state.updateDisplay,
        }}
      >
        Update
      </span>
      <span
        style={{
          display: this.state.spinning,
        }}
      >
        <ClipLoader color={'grey'} loading={true} size={20} />
      </span>
    </button>
  )

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = localStorage.getItem('partnername')
          dashboard = 'in'
        }
      } else {
        accountname = localStorage.getItem('businessname')
        dashboard = 'dashboard'
      }
    } else {
      accountname = localStorage.getItem('customername')
      dashboard = 'customerdashboard'
    }
    const customername = accountname
    const dtregistered = this.props.location.state?.dtregistered

    const accounttype = localStorage.getItem('accounttype')

    const isPartner =
      localStorage.getItem('customername') === null && localStorage.getItem('businessname') === null
    const avatarSrc = this.state.photoPreview || photoSrc(this.state.profile_photo)

    const { collapsed, isMobile } = this.state
    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}

        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}

        {this.state.isMobile && this.state.collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <main
          className="ep-page"
          style={{
            marginTop: 'var(--header-h)',
            marginLeft: this.state.isMobile ? 0 : this.state.collapsed ? '76px' : '252px',
          }}
        >
          <div className="ep-container">
            <button type="button" className="ep-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <div className="ep-head">
              <h1>Edit profile</h1>
              <p>Keep your details up to date.</p>
            </div>

            {/* Details */}
            <section className="ep-card">
              <div className="ep-card__head">
                <h2>
                  <IoPersonOutline size={18} />
                  Details
                </h2>
              </div>

              <div className="ep-form">
                <label className="ep-field ep-field--wide">
                  <span>
                    {localStorage.getItem('customername')
                      ? 'Name and surname'
                      : localStorage.getItem('businessname')
                        ? 'Business name'
                        : 'Name and surname'}
                  </span>
                  <input
                    type="text"
                    placeholder={
                      localStorage.getItem('customername') ? 'Name and surname' : 'Business name'
                    }
                    value={this.state.accountname}
                    onChange={this.handleCustomername}
                    className="ep-input"
                  />
                </label>

                <label className="ep-field">
                  <span>Email</span>
                  <input
                    type="email"
                    placeholder="Email address"
                    value={this.state.email}
                    onChange={this.handleEmail}
                    className="ep-input"
                  />
                </label>

                <label className="ep-field">
                  <span>Phone number</span>
                  <input
                    type="text"
                    placeholder="Phone number"
                    value={this.state.phone}
                    onChange={this.handlePhone}
                    className="ep-input"
                  />
                </label>
              </div>

              {localStorage.getItem('customername') ? (
                <div className="ep-foot">{this.renderUpdateButton()}</div>
              ) : (
                ''
              )}
            </section>

            {/* Public profile (partner only) */}
            {isPartner && (
              <section className="ep-card">
                <div className="ep-card__head">
                  <div>
                    <h2>
                      <IoImageOutline size={18} />
                      Your profile
                    </h2>
                    <p>Organisers see this when they open your link</p>
                  </div>
                </div>

                <div className="ep-form">
                  <div className="ep-photo">
                    <div className="ep-photo__avatar">
                      {avatarSrc ? (
                        <img src={avatarSrc} alt="Profile" />
                      ) : (
                        (this.state.accountname || '?').charAt(0).toUpperCase()
                      )}
                    </div>

                    <div className="ep-photo__meta">
                      <label className="ep-btn ep-btn--primary ep-photo__btn">
                        {avatarSrc ? 'Change photo' : 'Upload photo'}
                        <input
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          onChange={this.handlePhoto}
                          hidden
                        />
                      </label>
                      <p className="ep-photo__hint">
                        JPG, PNG or WEBP, up to 2MB.
                        {this.state.photoFile ? ' Click Update to save.' : ''}
                      </p>
                    </div>
                  </div>

                  <label className="ep-field">
                    <span>Affiliate type</span>
                    <select
                      value={this.state.partner_type}
                      onChange={this.handlePartnerType}
                      className="ep-input"
                    >
                      <option value="">Select type</option>
                      <option value="org">Organisation</option>
                      <option value="individual">Individual</option>
                    </select>
                  </label>

                  <label className="ep-field">
                    <span>Follower estimate</span>
                    <select
                      value={this.state.follower_estimate}
                      onChange={this.handleFollowerEstimate}
                      className="ep-input"
                    >
                      <option value="">Select range</option>
                      <option value="Less than 500">Less than 500</option>
                      <option value="500-2K">500–2K</option>
                      <option value="2K-10K">2K–10K</option>
                      <option value="10K+">10K+</option>
                    </select>
                  </label>

                  <label className="ep-field ep-field--wide">
                    <span>
                      Bio ({this.state.bio.length}/{BIO_MAX})
                    </span>
                    <textarea
                      value={this.state.bio}
                      onChange={this.handleBio}
                      placeholder="Tell organisers who you are and what you do"
                      className="ep-input ep-textarea"
                      rows={4}
                    />
                  </label>

                  <label className="ep-field ep-field--wide">
                    <span>
                      Pitch ({this.state.pitch.length}/{PITCH_MAX})
                    </span>
                    <textarea
                      value={this.state.pitch}
                      onChange={this.handlePitch}
                      placeholder="Why organisers should work with you"
                      className="ep-input ep-textarea"
                      rows={4}
                    />
                  </label>
                </div>
              </section>
            )}

            {/* Social accounts (business / partner) */}
            {localStorage.getItem('customername') ? (
              ''
            ) : (
              <section className="ep-card">
                <div className="ep-card__head">
                  <div>
                    <h2>
                      <IoShareSocialOutline size={18} />
                      Social accounts
                    </h2>
                    <p>Make it easy for your attendees to find you</p>
                  </div>
                </div>

                <div className="ep-form">
                  <label className="ep-field ep-field--wide">
                    <span>Facebook profile URL</span>
                    <input
                      type="text"
                      placeholder="https://facebook.com/username"
                      value={this.state.facebook}
                      onChange={this.handleFacebook}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>X handle</span>
                    <input
                      type="text"
                      placeholder="https://x.com/username"
                      value={this.state.twitter}
                      onChange={this.handleTwitter}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>Instagram handle</span>
                    <input
                      type="text"
                      placeholder="https://instagram.com/username"
                      value={this.state.instagram}
                      onChange={this.handleInstagram}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>Linkedin profile URL</span>
                    <input
                      type="text"
                      placeholder="https://linkedin.com/in/username"
                      value={this.state.linkedin}
                      onChange={this.handleLinkedin}
                      className="ep-input"
                    />
                  </label>

                  <label className="ep-field">
                    <span>Tiktok handle</span>
                    <input
                      type="text"
                      placeholder="https://www.tiktok.com/username"
                      value={this.state.tiktok}
                      onChange={this.handleTiktok}
                      className="ep-input"
                    />
                  </label>

                  {this.state.loggedAccountType !== 'business' ? (
                    ''
                  ) : (
                    <label className="ep-field ep-field--wide">
                      <span>Business address</span>
                      <textarea
                        value={
                          this.state.address == 'null' || this.state.address == null
                            ? ''
                            : this.state.address
                        }
                        onChange={this.handleAddress}
                        placeholder="Address"
                        className="ep-input ep-textarea"
                        rows={3}
                      />
                    </label>
                  )}
                </div>

                <div className="ep-foot">{this.renderUpdateButton()}</div>
              </section>
            )}
          </div>
        </main>

        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
      </div>
    )
  }
}

export default Editprofile
